import {FlattenedNodesObserver} from '@polymer/polymer/lib/utils/flattened-nodes-observer.js';
import {dedupingMixin} from "@polymer/polymer/lib/utils/mixin";

/**
 * @polymer
 * @mixinFunction
 **/
export const PanelDynamicRegionBehavior = dedupingMixin((superClass) => class extends superClass {
  static get properties() {
    return {
      regionIsVisible: {type: Boolean, observer: 'handleRegionVisibilityChanged'}
    };
  }

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('panel-controller-visibility', this._setPanelRegionVisibility);

    this._observer = new FlattenedNodesObserver(this, () => {
      this._setPanelRegionVisibility();
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('panel-controller-visibility', this._setPanelRegionVisibility);

    if (this._observer) {
      this._observer.disconnect();
      this._observer = null;
    }
  }

  handleRegionVisibilityChanged() {
    console.warn('%cPanel Dynamic Region Behavior:', 'background: #fc0; color: #000', 'Method `handleRegionVisibilityChanged` not defined.');
  }

  _setPanelRegionVisibility() {
    const nodes = FlattenedNodesObserver.getFlattenedNodes(this);
    let visibleNodeCount = nodes.length;
    nodes.forEach((node) => {
      if (node.hasAttribute('hidden')) {
        --visibleNodeCount;
      }
    });

    this.regionIsVisible = !!visibleNodeCount;
  }
});
